import React from 'react';

import { Center } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import Countdown from 'components/countdown';
import BlockRenderer from 'components/sanity-block-renderer';
import { Box, BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const StyledCountdown = Countdown;

export const ModalInner = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.modalInner, style] });

export const PictureHeading = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.pictureHeading, style] });

export const BodyContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.bodyContent, style] });

export const ShortCodeWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.shortCodeWrapper, style] });

export const ShortCode = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.shortCode, style] });

export const CouponTitle = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.couponTitle, style] });

export const Name = BlockRenderer.withConfig({
  textProps: {
    textAlign: 'center',
    textTransform: 'uppercase',
    lineHeight: 'xs',
    fontSize: {
      base: '4xl',
      md: '3xl',
    },
    fontFamily: 'heading',
    fontWeight: 'bold',
  },
});

export const Description = BlockRenderer.withConfig({
  textProps: {
    textAlign: 'center',
    color: primitive.$bbqBrown,
    fontSize: {
      base: 'lg',
      md: 'xl',
    },
  },
});

export const Directions = Center.withConfig({
  marginTop: '$4',
});

export const RedeemInNext = withTypography({
  fontSize: 'lg',
  bold: true,
  color: primitive.$bbqBrown,
  mb: '$1',
});

export const UseCodeAtCashier = withTypography({
  mt: '$4',
  mx: '$0',
  color: primitive.$bbqBrown,
  bold: true,
  fontSize: 'lg',
  textAlign: 'center',
  style: { marginBottom: spacing.$1_5 },
});

const styles = StyleSheet.create({
  modalInner: {
    backgroundColor: getDesignToken('background-default'),
    height: '100%',
    overflow: 'scroll',
    width: '100%',
  },
  pictureHeading: { flexGrow: 0, margin: spacing.$8 },
  bodyContent: { flexGrow: 1, padding: spacing.$4, position: 'relative' },
  shortCodeWrapper: {
    alignSelf: 'center',
    backgroundColor: primitive.$bbqBrown,
    borderRadius: 24,
    elevation: 1,
    padding: spacing.$1,
  },
  shortCode: { padding: spacing.$1_5 },
  couponTitle: { marginBottom: spacing.$1_5, marginTop: spacing.$2 },
});
